import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { ColorProps } from 'types/calendar';

const initialState: ColorProps = {
    colors: [],
};

const color = createSlice({
    name: 'color',
    initialState,
    reducers: {
        setColors(state, action) {
            state.colors = action.payload;
        },
    },
});

export default color.reducer;

export const { setColors } = color.actions;

export const selectColors = createSelector([(state: RootState) => state.color], (color) => {
    return color.colors;
});
